import { createDeviceTelemetrySaga } from '../Telemetry/deviceTelemetrySagas';
import { DeviceTelemetryType } from '@signageos/common-types/dist/Device/Telemetry/DeviceTelemetryType';
import IGetTelemetryProperties from '../Telemetry/IGetTelemetryProperties';
import { MonitoringLogData } from '@signageos/common-types/dist/Device/MonitoringLog/MonitoringLogData';
import ManagementCapability from '../../../NativeDevice/Management/ManagementCapability';
import Responsibility from '../../../Feature/Responsibility';
import { withDependencies } from '../../../DI/dependencyInjection';
import { IResponsibilities } from '../../../Feature/Responsibilities';
import IManagementDriver from '../../../NativeDevice/Management/IManagementDriver';
import { IPropertyStorage } from '../../../Property/propertyStorage';
import { IProprietaryTimerStorage } from '../../../Timer/ITimerStorage';
import { PowerActionRules } from '../../../NativeDevice/Power/IPowerActionTimer';
import { call } from 'redux-saga/effects';

const baseTelemetrySaga = createDeviceTelemetrySaga(
	DeviceTelemetryType.CPU_USAGE,
	Responsibility.TELEMETRY,
	[ManagementCapability.SYSTEM_CPU],
	getCpuUsageSettings,
);

// Create saga that checks feature flags before creating CPU telemetry
const cpuTelemetryWithFeatureFlag = withDependencies(
	['featureFlags'],
	function* (
		{ featureFlags },
		responsibilities: IResponsibilities,
		getManagementDriver: () => IManagementDriver,
		propertyStorage: IPropertyStorage,
		timerStorage: IProprietaryTimerStorage,
		powerActionRules: () => Promise<PowerActionRules>,
		applicationVersion: string,
	) {
		// Check if CPU usage telemetry is enabled (default to false to match config)
		if (!(featureFlags?.cpuUsage ?? false)) {
			return;
		}
		// Create and yield the standard telemetry saga
		const telemetrySaga = baseTelemetrySaga(
			responsibilities,
			getManagementDriver,
			propertyStorage,
			timerStorage,
			powerActionRules,
			applicationVersion,
		);
		yield telemetrySaga;
	},
);

// Export wrapper function that properly calls the withDependencies saga
export function* telemetryCpuUsageSettingsSaga(
	responsibilities: IResponsibilities,
	getManagementDriver: () => IManagementDriver,
	propertyStorage: IPropertyStorage,
	timerStorage: IProprietaryTimerStorage,
	powerActionRules: () => Promise<PowerActionRules>,
	applicationVersion: string,
) {
	// Actually call the withDependencies saga with parameters
	yield call(
		cpuTelemetryWithFeatureFlag,
		responsibilities,
		getManagementDriver,
		propertyStorage,
		timerStorage,
		powerActionRules,
		applicationVersion,
	);
}

export async function getCpuUsageSettings({
	managementDriver,
}: IGetTelemetryProperties): Promise<MonitoringLogData[DeviceTelemetryType.CPU_USAGE]> {
	try {
		const usage = await managementDriver.systemInfo.getCpuUsage();
		return {
			usage,
		};
	} catch (error) {
		throw error;
	}
}
